var heading_default = {
  "fontElementMap": "_4lgwv",
  "elementSpacing": "JYm-u",
  "headerOne": "Ms8Sm JYm-u",
  "headerTwo": "DMTsv JYm-u",
  "headerThree": "o26M4 JYm-u",
  "headerFour": "-qWHB JYm-u",
  "headerFive": "B1cN4 JYm-u",
  "headerSix": "URvW4 JYm-u",
  "child": "M0K9x"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
